import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@material-ui/core";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import {
  useHasRights,
  useUserRights,
} from "../../../contexts/UserRightsContext";
import Changes from "../../common/Changes";
import PlayerHistory from "./PlayerHistory";
import PlayerMarketing from "./PlayerMarketing";
import PlayerNotes from "./PlayerNotes";
import PlayerOpenBets from "./PlayerOpenBets";
import PlayerPayment from "./PlayerPayment";
import PlayerSettings from "./PlayerSettings";
import "./PlayerTabs.css";
import PlayerWagering from "./PlayerWagering";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import PlayerInfo2 from '../../players/playerComponents/PlayerInfo';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index || props.hidden}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function PlayerModifyMassive(props) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const location = useLocation();
  const history = useHistory();
  const ids2 = location.state?.ids || [];
  const agentName = location.state?.AgentName || "";

  useEffect(() => {
    if (!ids2.length) {
      history.replace("/players");
    }
  }, [ids2, history]);

  const [initialNotes, setInitialNotes] = useState({
    Notes0: "",
    Notes1: "",
    Notes2: "",
    Notes3: "",
    Notes4: "",
    Notes5: "",
    Notes6: "",
  });


  const [bulkNotes, setBulkNotes] = useState({
    Notes0: "",
    Notes1: "",
    Notes2: "",
    Notes3: "",
    Notes4: "",
    Notes5: "",
    Notes6: "",
  });

  const handleNotesChangeFromChild = (next) => {
    setBulkNotes(next);
  };

  const [Players, setPlayers] = useState([]);

  console.log("IDs recibidos:", ids2);

  const query = useQuery();
  const ids = (query.get("ids") || "")
    .split(",")
    .map(s => s.trim())
    .filter(Boolean)
    .map(Number);

  useEffect(() => {
    console.log("IDS: ", ids);
  }, [ids])

  const [PlayerInfo, setPlayerInfo] = useState(getEmptyPlayerInfo());
  const originalRef = useRef(null);
  useEffect(() => {
    // si tu base es vacío:
    setPlayerInfo(getEmptyPlayerInfo());
    originalRef.current = deepClone(getEmptyPlayerInfo());

  }, [Players]);

  const saveNotes = async () => {
    const payload = ids2.map((id) => ({
      IdPlayer: id,
      Notes0: bulkNotes.Notes0 ?? "",
      Notes1: bulkNotes.Notes1 ?? "",
      Notes2: bulkNotes.Notes2 ?? "",
      Notes3: bulkNotes.Notes3 ?? "",
      Notes4: bulkNotes.Notes4 ?? "",
      Notes5: bulkNotes.Notes5 ?? "",
      Notes6: bulkNotes.Notes6 ?? "",
    }));
    console.log("NOTAS: ", payload)

    if (JSON.stringify(initialNotes) === JSON.stringify(bulkNotes)) {
      return;
    }

    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Player/PlayerNotesMaintenanceBulk",
      data: payload,
    })
      .then((response) => {
        if (response.data === 0) {
          setBulkNotes({
            Notes0: "",
            Notes1: "",
            Notes2: "",
            Notes3: "",
            Notes4: "",
            Notes5: "",
            Notes6: "",
          })
        }
        console.log("response", response);
      });

  }

  const onSave = async () => {

    if (!originalRef.current) return;

    const patch = buildDiffPatch(PlayerInfo, originalRef.current, {
      trimStrings: true,
      treatEmptyAsNoop: false,
    });

    if (Object.keys(patch).length === 0) {
      return;
    }

    const mergedRows = Players.map(p => ({ ...p, ...patch }));

    const bulkPayload = mergedRows.map(row => mapRowToRequestDTO(row, userInfo));

    console.log("BULK PAYLOAD:", bulkPayload);

    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/player/Player_Update_Bulk",
      data: bulkPayload,
    }).then((response) => {
      if (response.data === -1) {
        toast.error(`Error during bulk update`);
      } else {
        toast.success(`Successful bulk update`);
      }
    });

    originalRef.current = deepClone(PlayerInfo);
  };

  function getEmptyPlayerInfo() {
    return {
      IdPlayer: 0,
      IdLineType: 0,
      IdOffice: 0,
      IdAgent: 0,
      IdCurrency: 0,
      IdGrouping: 0,
      IdSource: 0,
      IdProfile: 0,
      IdProfileLimits: 0,
      IdPlayerRate: 0,
      IdBook: 0,
      IdTimeZone: 0,
      IdLanguage: 0,
      ScheduleStyle: "",
      Player: "",
      Password: "",
      Name: "",
      LastName: "",
      LastName2: "",
      Title: "",
      Address1: "",
      Address2: "",
      City: "",
      State: "",
      Country: "",
      Zip: "",
      Phone: "",
      Fax: "",
      Email: "",
      Status: "",
      AutoPay: false,
      BalanceChecked: false,
      CreditLimit: 0,
      TempCredit: 0,
      SoftLimitPercent: 0,
      TempCreditExpire: null,
      OnlineAccess: false,
      OnlinePassword: "",
      OnlineMessage: "",
      OnlineMaxWager: 0,
      OnlineMinWager: 0,
      MaxWager: 0,
      MinWager: 0,
      CapPerGame: 0,
      ChartPercent: 0,
      MasterChart: 0,
      Master: false,
      FlagMessage: "",
      IdFlagMessageType: 0,
      MaxActionPoints: 0,
      BonusPointsStatus: "",
      BonusPointsExpire: null,
      BonusPointsStart: null,
      LineStyle: "",
      NHLLine: "",
      MLBLine: "",
      PitcherDefault: 0,
      DuplicatedBets: false,
      DuplicatedBetsOnline: false,
      FreePlayAmount: 0,
      FreePlayMessage: "",
      ScheduleFB: false,
      ScheduleBB: false,
      ScheduleHK: false,
      ScheduleBS: false,
      SettledFigure: 0,
      ShowInTicker: false,
      EPOSPlayer: false,
      EnableHorses: false,
      EnableCasino: false,
      EnableSports: false,
      EnableCards: false,
      DateOfBirth: null,
      SignUpIP: "",
      SecQuestion: "",
      SecAnswer: "",
      HoldBets: false,
      HoldDelay: 0,
      AllowNegTrans: false,
      IdAffiliate: null,
      LastModificationUser: 0,
      Reset_Password: false,
      Currency: "",
      Symbol: "",
      MoneyChange: 0,
      AgentEnabled: false,
      DontXFerPlayerActivity: false,
      BannedPlayer: 0,
      OfficeName: "",
      PlayerRateName: "",
      LineTypeName: "",
      MasterAgentEnabled: false,
    };
  }


  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSave = () => {
    if (props.Player.IdPlayer == 0) {
      props.InsertPlayer(props.Player);
    } else {
      props.Updateplayer(props.Player);
    }
  };

  const handleClose = () => {
    history.push("/profiles");
  };

  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const onDateChange = useCallback((event) => setDate(event.target.value), []);

  const [reason, setReason] = useState("");
  const onReasonChange = useCallback(
    (event) => setReason(event.target.value),
    []
  );

  const requestPlayers = useCallback(
    (userId) => {
      const url =
        process.env.REACT_APP_API2_URL +
        "/Player/Player_GetInfoByIDs";
      axios
        .post(url, ids2)
        .then((response) => response.data)
        .then((data) => {
          const clonedData = JSON.parse(JSON.stringify(data));
          setPlayers(clonedData);
        });
    },
    [props.match.params.id]
  );

  useEffect(() => {
    if (ids2.length > 0) {
      requestPlayers();
    }
  }, [ids2])

  const handleChangeClone = (event) => {
    const { name, value } = event.target;
    setClonePlayer((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Si se requiere que estos datos formen parte de la data para insert, se podría:
    // props.updatePlayerField(name, value);
  };

  const [openBlackBook, setOpenBlackBook] = useState(false);
  const onOpenBlackBookChange = useCallback(
    (open) => setOpenBlackBook(open),
    []
  );

  const handleBlackBook = useCallback(() => {
    const url = `${process.env.REACT_APP_API2_URL}/Player/Player_InsertBlackBook`;
    axios
      .post(url, {
        IdPlayer: props.Player.IdPlayer,
        SettleDate: date,
        Description: reason,
        IdUser: userInfo.userId,
      })
      .then((response) => {
        if (response.data === 0) {
          toast.error(`Error blacklisting player ${props.Player.Player}`);
        } else {
          toast.success(`${props.Player.Player} blacklisted successfully`);
        }
        onOpenBlackBookChange(false);
      });
  }, [props.Player, date, reason, userInfo.userId, onOpenBlackBookChange]);

  const [openResetStatistics, setOpenResetStatistics] = useState(false);
  const [isClone, setIsClone] = useState(false);
  const [clonePlayer, setClonePlayer] = useState({
    Player: "",
    Password: "",
    Name: "",
    LastName: "",
    LastName2: "",
  });

  const onOpenResetStatisticsChange = useCallback(
    (open) => setOpenResetStatistics(open),
    []
  );

  const updatePlayerField = (field, value) => {
    setPlayerInfo((prev) => ({ ...prev, [field]: value }));
  };

  const toggleIsClone = () => {
    setIsClone(!isClone);
  };

  const ClonePlayer = () => {
    if (clonePlayer.Player === "" || clonePlayer.Password === "") {
      return;
    }

    let request = {
      SourcePlayer: props.Player.IdPlayer,
      Player: clonePlayer.Player,
      Password: clonePlayer.Password,
      Name: clonePlayer.Name,
      LastName: clonePlayer.LastName,
      LastName2: clonePlayer.LastName2,
      Title: "Mr",
      OnlinePassword: clonePlayer.Password,
      IdUser: userInfo.IdUser,
      IdPlayer: props.Player.IdPlayer,
      Result: 0,
    };

    console.log(request);
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Player/Player_Clone",
      data: request,
    }).then((response) => {
      console.log("response", response);
      if (response.data.Result === 0) {
        setIsClone(false);
        toast.success(`Player cloned successfully.`);
      } else {
        toast.error(`An error occurred while cloning the player.`);
      }
    });
  };

  const handleResetStatistics = useCallback(() => {
    const url = `${process.env.REACT_APP_API2_URL}/Player/Player_ResetStats`;
    axios
      .post(url, {
        IdPlayer: props.Player.IdPlayer,
        IdUser: userInfo.userId,
      })
      .then((response) => {
        if (response.data === -1) {
          toast.error(`Error reseting stats for player ${props.Player.Player}`);
        } else {
          toast.success(`${props.Player.Player} stats reset successfully`);
        }
        onOpenResetStatisticsChange(false);
        props.requestPlayerInfo();
      });
  }, [props.Player, userInfo.userId, onOpenResetStatisticsChange, props.requestPlayerInfo]);

  const canBlackBook = useHasRights(30);

  const { data: rights } = useUserRights();
  const hasRights = useCallback(
    (...ids) => ids.some((id) => rights?.includes(id)),
    [rights]
  );

  const mapRowToRequestDTO = (row, userInfo) => ({
    prmIdPlayer: row.IdPlayer,
    prmIdLineType: row.IdLineType,
    prmIdOffice: row.IdOffice,
    prmIdAgent: row.IdAgent,
    prmIdCurrency: row.IdCurrency,
    prmIdGrouping: row.IdGrouping,
    prmIdSource: row.IdSource,
    prmIdProfile: row.IdProfile,
    prmIdProfileLimits: row.IdProfileLimits,
    prmIdPlayerRate: row.IdPlayerRate ?? 1,
    prmIdBook: row.IdBook,
    prmIdTimeZone: row.IdTimeZone,
    prmIdLanguage: row.IdLanguage,
    prmScheduleStyle: row.ScheduleStyle,
    prmPlayer: row.Player,
    prmPassword: row.Password,
    prmName: row.Name,
    prmLastName: row.LastName,
    prmLastName2: row.LastName2,
    prmAddress1: row.Address1,
    prmAddress2: row.Address2,
    prmCity: row.City,
    prmState: row.State,
    prmCountry: row.Country,
    prmZip: row.Zip,
    prmPhone: row.Phone,
    prmFax: row.Fax,
    prmEmail: row.Email,
    prmStatus: row.Status,
    prmAutoPay: row.AutoPay,
    prmBalanceChecked: row.BalanceChecked,
    prmCreditLimit: row.CreditLimit,
    prmTempCredit: row.TempCredit,
    prmSoftLimitPercent: row.SoftLimitPercent,
    prmTempCreditExpire: row.TempCreditExpire,
    prmOnlineAccess: row.OnlineAccess,
    prmOnlinePassword: row.OnlinePassword,
    prmOnlineMessage: row.OnlineMessage,
    prmOnlineMaxWager: row.OnlineMaxWager,
    prmOnlineMinWager: row.OnlineMinWager,
    prmMaxWager: row.MaxWager,
    prmMinWager: row.MinWager,
    prmChartPercent: row.ChartPercent,
    prmMasterChart: row.MasterChart,
    prmMaster: row.Master,
    prmFlagMessage: row.FlagMessage,
    prmIdFlagMessageType: row.IdFlagMessageType,
    prmMaxActionPoints: row.MaxActionPoints,
    prmBonusPointsStatus: row.BonusPointsStatus,
    prmBonusPointsExpire: row.BonusPointsExpire,
    prmBonusPointsStart: row.BonusPointsStart,
    prmLineStyle: row.LineStyle,
    prmNHLLine: row.NHLLine,
    prmMLBLine: row.MLBLine,
    prmPitcherDefault: row.PitcherDefault,
    prmDuplicatedBets: row.DuplicatedBets,
    prmDuplicatedBetsOnline: row.DuplicatedBetsOnline,
    prmScheduleFB: row.ScheduleFB,
    prmScheduleBB: row.ScheduleBB,
    prmScheduleHK: row.ScheduleHK,
    prmScheduleBS: row.ScheduleBS,
    prmSettledFigure: row.SettledFigure,
    prmShowInTicker: row.ShowInTicker,
    prmEPOSPlayer: row.EPOSPlayer,
    prmEnableSports: row.EnableSports,
    prmEnableCasino: row.EnableCasino,
    prmEnableHorses: row.EnableHorses,
    prmDateOfBirth: row.DateOfBirth,
    prmSecQuestion: row.SecQuestion,
    prmSecAnswer: row.SecAnswer,
    prmSignUpIP: row.SignUpIP ?? "192.168.3.20",
    prmHoldBets: row.HoldBets,
    prmHoldDelay: row.HoldDelay,
    prmIdAffiliate: row.IdAffiliate,
    prmIdUser: userInfo.userId,
  });

  return (
    <React.Fragment>
      <div className="flex flex-col w-full">
        <h2>Bulk changes for {agentName}</h2>
        <PlayerInfo2
          Player={PlayerInfo}
          UpdatePlayer={props.Updateplayer}
          updatePlayerField={updatePlayerField}
          isBulk={true}
        />
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          className="w-full mb-2 overflow-x-scroll tabs-class mt-3"
        >
          <Tab label="Wagering" {...a11yProps(0)} />
          <Tab label="Settings / Notes" {...a11yProps(1)} />
          {/* <Tab label="Online Messages" {...a11yProps(2)} /> */}
          <Tab label="Marketing" {...a11yProps(2)} />
        </Tabs>
        <hr className="my-2" />
        <TabPanel className="tab-content" value={value} index={0}>
          <PlayerWagering
            Player={PlayerInfo}
            UpdatePlayer={props.Updateplayer}
            updatePlayerField={updatePlayerField}
            isBulk={true}
          />
        </TabPanel>
        <TabPanel className="tab-content" value={value} index={1}>
          <PlayerSettings
            Player={PlayerInfo}
            UpdatePlayer={props.Updateplayer}
            isBulk={true}
            playerNotesB={bulkNotes}
            onNotesChange={handleNotesChangeFromChild}
          />
        </TabPanel>
        {/* <TabPanel className="tab-content" value={value} index={2}>
                <PlayerNotes Player={PlayerInfo} />
            </TabPanel> */}
        <TabPanel className="tab-content" value={value} index={2}>
          <PlayerMarketing
            Player={PlayerInfo}
            UpdatePlayer={props.Updateplayer}
            isBulk={true}
          />
        </TabPanel>

        <div className="flex flex-row justify-between gap-4">
          <div className="flex flex-row gap-4 mt-4">
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={(e) => {
                onSave();
                saveNotes();
              }}
            >
              Save
            </Button>

            {/* <Button size="small" variant="contained" color="primary" onClick={toggleIsClone}>
                    Clone
                </Button>
                <Button
                    hidden={!canBlackBook}
                    size="small"
                    variant="contained"
                    color="secondary"
                    onClick={() => onOpenBlackBookChange(true)}
                >
                    Black Book
                </Button>
                <Button
                    size="small"
                    variant="contained"
                    color="secondary"
                    onClick={() => onOpenResetStatisticsChange(true)}
                >
                    Reset Stats
                </Button> */}
          </div>

          {/* <Changes
                hidden={!hasRights(41)}
                title="Player Changes"
                params={{
                    ChangeType: 1,
                    IdSport: "",
                    Param1: props.Player.IdPlayer,
                    Param2: 0,
                    Param3: 0,
                }}
                /> */}
        </div>
      </div>

    </React.Fragment>
  );
}

function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}


function isEqualValue(a, b) {
  const aTime = typeof a === "string" ? Date.parse(a) : NaN;
  const bTime = typeof b === "string" ? Date.parse(b) : NaN;
  if (!isNaN(aTime) || !isNaN(bTime)) {
    return aTime === bTime;
  }

  if (typeof a === "object" || typeof b === "object") {
    return JSON.stringify(a ?? null) === JSON.stringify(b ?? null);
  }
  return a === b;
}

function buildDiffPatch(current, original, opts = {}) {
  const ignore = new Set([...(opts.ignore || [])].map(String));
  const patch = {};

  Object.keys(current).forEach(k => {
    if (ignore.has(k)) return;

    let a = current[k];
    let b = original[k];

    if (opts.trimStrings) {
      if (typeof a === "string") a = a.trim();
      if (typeof b === "string") b = b.trim();
    }

    if (opts.treatEmptyAsNoop && (a === "" || a === null || typeof a === "undefined")) {
      return;
    }

    if (!isEqualValue(a, b)) {
      patch[k] = a;
    }
  });

  return patch;
}